import { specificationService } from "@/shared/services/api/specification-service";
import { ISpecificationExploreRequest, ISpecificationProductExploreRequest } from "@/shared/services/interface/requests/specification";
import { createAsyncThunk } from "@reduxjs/toolkit";


export const startProductExplore = createAsyncThunk(
  "specificationExplore/startProductExplore",
  async (payload: ISpecificationExploreRequest, thunkAPI) => {
    try {
      const responseCompareProducts = await specificationService.productExplore(
        {
          specificationId: payload.specificationId,
          section: payload.section,
          isRediscover: payload.isRediscover,
        }
      );
      if (responseCompareProducts.success) {
        return {response: responseCompareProducts, section: payload.section};
      }
      return {response: responseCompareProducts, section: payload.section};
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const getProductExplore = createAsyncThunk(
  "specificationExplore/getProductExplore",
  async (payload: ISpecificationProductExploreRequest, thunkAPI) => {
    try {
      const response = await specificationService.getProductExplore(payload);
      if (response.success) {
        return response.data;
      }
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);


export const getWithSectionProductExplore = createAsyncThunk(
  "specificationExplore/getWithSectionProductExplore",
  async (payload: ISpecificationProductExploreRequest, thunkAPI) => {
    try {
      const response = await specificationService.getProductExplore(payload);
      if (response.success) {
       
        return { data: response.data, section: payload.section || 0 };
      }
      return { data: response.data, section: payload.section || 0 };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);


export const getWithSectionProductExploreHandler = createAsyncThunk(
  "specificationExplore/getWithSectionProductExploreHandler",
  async (payload: ISpecificationProductExploreRequest, thunkAPI) => {
    try {
      const response = await specificationService.getProductExplore(
        { ...payload, section: payload.section },
        `?section=${payload.section}`
      );
      if (response.success) {
        return { ...response, section: payload.section };
      }
      return { ...response, section: payload.section };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);


export const getWithSectionProductExplore1 = createAsyncThunk(
  "specificationExplore/getWithSectionProductExplore1",
  async (payload: ISpecificationProductExploreRequest, thunkAPI) => {
    try {
      const response = await specificationService.getProductExplore(
        { ...payload, section: 1 },
        "?section=1"
      );
      if (response.success) {
        return response;
      }
      return response ;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getWithSectionProductExplore2 = createAsyncThunk(
  "specificationExplore/getWithSectionProductExplore2",
  async (payload: ISpecificationProductExploreRequest, thunkAPI) => {
    try {
      const response = await specificationService.getProductExplore(
        { ...payload, section: 2 },
        "?section=2"
      );
      if (response.success) {
        return response.data;
      }
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getWithSectionProductExplore3 = createAsyncThunk(
  "specificationExplore/getWithSectionProductExplore3",
  async (payload: ISpecificationProductExploreRequest, thunkAPI) => {
    try {
      const response = await specificationService.getProductExplore(
          { ...payload, section: 3 },
          "?section=3"
        );
      if (response.success) {
        return response.data;
      }
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getWithSectionProductExplore4 = createAsyncThunk(
  "specificationExplore/getWithSectionProductExplore4",
  async (payload: ISpecificationProductExploreRequest, thunkAPI) => {
    try {
      const response = await specificationService.getProductExplore(
        { ...payload, section: 4 },
        "?section=4"
      );
      if (response.success) {
        return response.data;
      }
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getWithSectionProductExplore5 = createAsyncThunk(
  "specificationExplore/getWithSectionProductExplore5",
  async (payload: ISpecificationProductExploreRequest, thunkAPI) => {
    try {
      const response = await specificationService.getProductExplore(
        { ...payload, section: 5 },
        "?section=5"
      );
      if (response.success) {
        return response.data;
      }
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
